<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <v-snack-bar :snackbar="snackbar" />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import setupInactivityWatcher from '@/store/utils/inactivityWatcher';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'App',
  components: { VSnackBar },

  computed: {
    ...mapGetters('notifications', ['snackbar']),
  },

  mounted() {
    setupInactivityWatcher({
      store: this.$store,
      router: this.$router,
      onLogout: this.showLogoutMessage,
    });
  },

  methods: {
    ...mapActions('notifications', ['triggerSnackbar']),

    showLogoutMessage() {
      this.snackbar.visible = false;
      this.snackbar.visible = true;
      this.snackbar.content = 'La sesión se cerró por inactividad de 2 horas.';
      this.snackbar.timeout= '-1'
    },
  },
};
</script>

<style>
/* Ocultar en Firefox, IE y Edge */
html, body {
  -ms-overflow-style: none; /* IE y Edge */
  scrollbar-width: none; /* Firefox */
}

/* Ocultar en Chrome, Safari, Opera y navegadores móviles (iOS/Android) */
html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none; /* Crucial para dispositivos móviles */
  width: 0;
  height: 0;
  background: transparent;
}

div.v-select__slot:hover > div:nth-child(3) > div > button {
  visibility: visible;
}
</style>
